import { FlowContextProvider, StepWrapper } from '@betterment/js-runtime';
import { Route, Routes } from 'react-router-dom';

import { InitialProps } from './data';
import { SmsStartStep } from './SmsStartStep';
import { SmsVerifyStep } from './SmsVerifyStep';
import { TotpVerifyStep } from './TotpVerifyStep';

import { Modes, SmsDeliveryMethods } from '../../Shared/data';

const Controller: React.FC<InitialProps> = ({ returnToPath, mfaPhoneNumber, mfaMode }) => {
  if (mfaMode === Modes.totp) {
    return (
      <FlowContextProvider returnToPath={returnToPath}>
        <Routes>
          <Route
            path="/verify"
            element={
              <StepWrapper name="verify">
                <TotpVerifyStep />
              </StepWrapper>
            }
          />
        </Routes>
      </FlowContextProvider>
    );
  }
  const initialValues = {
    deliveryMethod: SmsDeliveryMethods.sms,
    mfaPhoneNumber,
  };
  return (
    <FlowContextProvider initialValues={initialValues} returnToPath={returnToPath}>
      <Routes>
        <Route
          path="/start"
          element={
            <StepWrapper name="start">
              <SmsStartStep />
            </StepWrapper>
          }
        />
        <Route
          path="/verify"
          element={
            <StepWrapper name="verify">
              <SmsVerifyStep />
            </StepWrapper>
          }
        />
      </Routes>
    </FlowContextProvider>
  );
};

export default Controller;
